import styled from 'styled-components'

import theme from 'theme_'
import { Font16 } from 'components/Typography'

export const ButtonItem = styled.li`
  padding: ${theme.spacing.xs} ${theme.spacing.base};
  cursor: pointer;
  ${Font16};
  transition: all 0.2s ease;

  &:hover {
    color: ${theme.colors.horizonOrange};
  }
`
